<script lang="ts">
  // A file's GitHub "Viewed" checkbox, as the sync with review marks has it
  // (see state/viewedSync.svelte.ts): an eye while viewed on GitHub, dimmed
  // while a write is on its way, outlined once a push changed the file
  // (DISMISSED), red when the sync failed. Nothing while unviewed.
  import type { FileSyncState } from '../state/viewedSync.svelte';

  let { state }: { state: FileSyncState | null } = $props();

  const title = $derived.by(() => {
    if (!state) return '';
    if (state.phase === 'error') return `GitHub's “Viewed” is not in step with your review: ${state.error}`;
    if (state.phase === 'sending') return state.github === 'VIEWED' ? 'Marking viewed on GitHub…' : 'Clearing “Viewed” on GitHub…';
    if (state.github === 'VIEWED') return 'Viewed on GitHub';
    if (state.github === 'DISMISSED') return 'Viewed on GitHub before it changed';
    return '';
  });
  const shown = $derived(!!state && (state.phase !== 'idle' || state.github === 'VIEWED' || state.github === 'DISMISSED'));
</script>

{#if state && shown}
  <span
    class="gh-viewed"
    class:sending={state.phase === 'sending'}
    class:error={state.phase === 'error'}
    class:dismissed={state.phase === 'idle' && state.github === 'DISMISSED'}
    data-viewed={state.github ?? ''}
    data-phase={state.phase}
    role="img"
    aria-label={title}
    {title}
    ><svg viewBox="0 0 16 16" aria-hidden="true"
      ><path d="M1 8s2.6-5 7-5 7 5 7 5-2.6 5-7 5-7-5-7-5Z" /><circle cx="8" cy="8" r="2.2" />{#if state.phase === 'error'}<path
          d="M2 14 14 2"
        />{/if}</svg
    ></span
  >
{/if}

<style>
  .gh-viewed {
    display: inline-flex;
    flex: 0 0 auto;
    width: 12px;
    height: 12px;
    color: var(--muted);
  }
  .gh-viewed svg {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.4;
  }
  .gh-viewed[data-viewed='VIEWED'] circle {
    fill: currentColor;
  }
  .gh-viewed.sending {
    opacity: 0.5;
  }
  .gh-viewed.dismissed {
    opacity: 0.6;
  }
  .gh-viewed.error {
    color: var(--bad);
  }
</style>
